module.exports = __webpack_public_path__ + "img/logo.577acc64.svg";